export default __webpack_public_path__ + "static/media/Survey.afa3d5fe.jpg";